import CodeEmployeeTypeList from "./pages/ListPage.vue";
import CodeEmployeeTypeDetail from "./pages/FormPage.vue";
import CodeEmployeeTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_employee_type",
    component: CodeEmployeeTypeIndex,
    redirect: "/code_employee_type/list",
    name: "code_employee_type",
    children: [
      {
        path: "list",
        component: CodeEmployeeTypeList,
        name: "code_employee_type.list",
      },
      {
        path: "create",
        component: CodeEmployeeTypeDetail,
        name: "code_employee_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeEmployeeTypeDetail,
        name: "code_employee_type.edit",
        props: { create: false },
      },
    ],
  },
];
